import React from "react";
import { CloudRain } from "lucide-react";
import type { AgendaWeatherAlert } from "../../agendaWeatherTypes";

type MobileWeatherVisitAlertProps = {
  alert: AgendaWeatherAlert;
  clientHint?: string | null;
};

const MobileWeatherVisitAlert: React.FC<MobileWeatherVisitAlertProps> = ({
  alert,
  clientHint,
}) => (
  <div className="mb-4 flex gap-2 rounded-xl border border-sky-200 bg-sky-50 px-3 py-2.5 text-sm text-sky-950">
    <CloudRain className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
    <div>
      <p className="font-semibold">{alert.title}</p>
      {clientHint ? (
        <p className="mt-0.5 text-[13px] text-sky-900/90">{clientHint}</p>
      ) : null}
    </div>
  </div>
);

export default MobileWeatherVisitAlert;
